module.exports = __webpack_public_path__ + "static/media/music-lover-radar-beliebers.41b53b22.png";